type TObject = Record<string, any>;

const orderObject = (rawObject: TObject): TObject =>
  Object.keys(rawObject)
    .sort()
    .reduce(
      (accumulator, key) => ({ ...accumulator, [key]: rawObject[key] }),
      {},
    );

export default orderObject;
